import { ReactElement } from 'react'
import { useAppSelector } from 'src/store/hooks'
import BaseLayout from 'src/v3/components/base-layout'
import { selectActiveClass } from './create.slice'
import {
  AccreditationIcon,
  ClassIcon,
  CourseIcon,
  DashboardIcon,
  LearningPathIcon,
  QuizIcon,
  SectionIcon,
  SeriesIcon,
  StoryboardIcon,
  TemplateIcon,
  TextContentIcon,
  TitleScreenIcon,
  VideoIcon,
} from '../core/icons'

interface Props {
  children: ReactElement | ReactElement[]
}

export default ({ children }: Props): ReactElement => {
  let activeClass = useAppSelector(selectActiveClass)
  let disabled = activeClass === 'unselected'

  return (
    <BaseLayout
      children={children}
      domain="create"
      role="creator"
      subMenuItems={[
        { name: 'Dashboard', route: '/', icon: <DashboardIcon /> },
        { name: 'Sections', route: '/section', icon: <SectionIcon /> },
        { name: 'Courses', route: '/course', icon: <CourseIcon /> },
        { name: 'Classes', route: '/class', icon: <ClassIcon /> },
        {
          name: 'Accreditations',
          route: '/accreditation',
          icon: <AccreditationIcon />,
        },
        { name: 'Templates', route: '/template', icon: <TemplateIcon /> },
        { name: 'Learning Paths', route: '/learning-path', icon: <LearningPathIcon /> },
        { name: 'Series', route: '/series', icon: <SeriesIcon /> },
        {
          name: 'Title Screen',
          route: '/title-screen',
          disabled,
          divider: true,
          icon: <TitleScreenIcon />,
        },
        { name: 'Videos', route: '/videos', disabled, icon: <VideoIcon /> },
        {
          name: 'Text Content',
          route: '/text-content',
          disabled,
          icon: <TextContentIcon />,
        },
        { name: 'Quiz', route: '/quiz', disabled, icon: <QuizIcon /> },
        {
          name: 'Storyboard',
          route: '/storyboard',
          disabled,
          icon: <StoryboardIcon />,
        },
      ]}
    />
  )
}
